<div class="flex f-fd--column">
  <div class="header-container">
    <howden-page-title></howden-page-title>
    @if (project) {
      <h3 class="client-name" i18n="@@app.sane-project-calculator.client">
        Cliente: {{ project.form.get('edit.projectClientName')?.value }}
      </h3>
    }
  </div>

  @if (project) {
    @if (showLife) {
      <howden-calculator-life></howden-calculator-life>
    }
    @if (showAccidents) {
      <howden-calculator-accidents></howden-calculator-accidents>
    }
    @if (showIT) {
      <howden-calculator-it></howden-calculator-it>
    }
    @if (showDependency) {
      <howden-calculator-dependence></howden-calculator-dependence>
    }
    @if (showDeaths) {
      <howden-calculator-deaths></howden-calculator-deaths>
    }

    <div class="flex margin-top-25">
      <div class="flex f-basis--6 f-jc--center f-ai--center">
        <button mat-raised-button color="cancel" (click)="onCancel()">
          Volver
        </button>
      </div>
      <div class="flex f-basis--6 f-jc--center f-ai--center">
        <button mat-raised-button color="success" (click)="onSubmit()">
          Calcular
        </button>
      </div>
    </div>
  }
</div>
